import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import useViewRealPlayQuery from 'features/realplays/services/queries/useViewRealplay';
import SubmitRealPlayHeader from '../SubmitRealPlay/SubmitRealPlayHeader';
import styles from '../SubmitRealPlay/Common.module.scss';
import SubmitReviewCard from 'features/roleplay/Components/SubmitReview/SubmitReviewCard';
import { CustomButton } from 'shared_ui_components';
import { useLocation, useHistory } from 'react-router-dom';
import useConfirmAssignmentStatusMutation from 'features/realplays/services/mutations/useConfirmAssignmentStatus';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const SubmitReviewRealplay = () => {
  const { uuid } = useParams();
  let location = useLocation();
  let history = useHistory();

  const { assignment_uuid, roleplay, scenarios } = RealPlayRecordDataHelper();

  const { data, isLoading: isRoleplayViewLoading } = useViewRealPlayQuery({
    uuid,
  });
  const { mutate: submitReview } = useConfirmAssignmentStatusMutation();

  const handleSubmit = () => {
    submitReview(
      { assignment_uuid },
      {
        onSuccess: () => {
          history.push({
            pathname: `/roleplay`,
            state: {
              prevPath: `${location.pathname}${location.search ? location.search : ''}`,
            },
          });
        },
      }
    );
  };

  const disabled = useMemo(
    () => scenarios?.every((item) => item?.response?.status && item?.response?.average != null),
    [scenarios]
  );

  if (isRoleplayViewLoading || !scenarios?.length > 0) return null;

  return (
    <Grid container direction="row" spacing={2} style={{ padding: '1rem 0 0 1rem', width: '100%' }}>
      <Grid item xs={12} md={8} lg={6} style={{ margin: '0 auto' }}>
        <div className={styles.background}>
          <SubmitRealPlayHeader data={data} />
          <div>
            {scenarios?.map((scenario, index) => {
              return (
                <SubmitReviewCard
                  title={scenario?.is_default === false ? scenario?.name : roleplay?.name}
                  description={scenario?.description ? scenario?.description : roleplay.description}
                  index={index + 1}
                  qualified={
                    scenario?.response_retake !== null
                      ? scenario?.response_retake.status
                      : scenario?.response.status
                  }
                  key={index}
                  stars={
                    scenario?.response_retake !== null
                      ? scenario?.response_retake.average
                      : scenario?.response.average
                  }
                />
              );
            })}
            <div className={styles.submitButton}>
              <CustomButton onClick={handleSubmit} disabled={!disabled}>
                Submit
              </CustomButton>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default SubmitReviewRealplay;
